<!-- 타겟그룹 라이브DI 필터 -->
<template>
  <div>
    <div v-if="isLiveDi">
      <!-- 라이브DI 설정 영역 -->
      <b-row class="mt-1">
        <b-col cols="12">
          <b-form-group>
            <label class="d-block">포함 livedi</label>
            <b-button
              :disabled="isReadonly"
              variant="outline-primary"
              class="mt-0"
              @click.prevent="showTargetGroupFilters(filterType, false)"
            >
              <feather-icon
                icon="SearchIcon"
                class="mr-50"
              />
              <span>라이브 DI 추가</span>
            </b-button>
          </b-form-group>
          <b-table
            :items="targetGroupData.targetGroupFilters.filter(x => x.filterType === filterType && !x.isExclude)"
            :fields="selectedTableColumns"
            sort-by="filterId"
            :sort-desc="true"
            bordered
            empty-text="추가된 라이브 DI가 없습니다."
          >
            <template #head(countType)>
              <span>
                처방 기준 설정
                <b-badge
                  v-b-tooltip.hover.right.html
                  variant="light-secondary"
                  style="padding: 0px; margin-left: 5px;"
                  :title="`<ul style='text-align: left; padding-left: 1rem; margin: 0;'>
                            <li>1일: 라이브DI 노출 기간 중 하루라도 설정한 처방 횟수 이상이면, 타겟그룹에 포함됩니다.</li>
                            <li>누적: 라이브DI 노출 기간 중 누적 처방 횟수가 설정한 처방 횟수 이상이면, 타겟그룹에 포함됩니다.</li>
                          </ul>`"
                >
                  <feather-icon icon="InfoIcon" />
                </b-badge>
              </span>
            </template>
            <template #cell(countType)="data">
              <b-form-radio-group
                v-model="data.item.countType"
                :options="codes.targetGroupCountType"
                :disabled="isReadonly"
                value-field="code"
                text-field="label"
              />
            </template>
            <template #cell(minCount)="data">
              <b-form-group class="mb-0">
                <div class="d-flex align-items-center">
                  <b-form-input
                    v-model.number="data.item.minCount"
                    type="number"
                    style="width: 55px;"
                    class="text-right"
                    :disabled="isReadonly"
                    @keyup="event => restrictToNumbers(event, data.item)"
                  />
                  <span class="ml-50">회 이상</span>
                </div>
              </b-form-group>
            </template>
            <template #cell(isDelete)="data">
              <b-button
                variant="link"
                size="sm"
                class="btn-hover-trash"
                :disabled="isReadonly"
                @click.prevent="removeRow(data.item)"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="16"
                  class="text-danger"
                />
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col cols="12">
          <b-form-group>
            <label class="d-block">제외 livedi</label>
            <b-button
              :disabled="isReadonly"
              variant="outline-primary"
              class="mt-0"
              @click.prevent="showTargetGroupFilters(filterType, true)"
            >
              <feather-icon
                icon="SearchIcon"
                class="mr-50"
              />
              <span>라이브 DI 추가</span>
            </b-button>
          </b-form-group>
          <b-table
            :items="targetGroupData.targetGroupFilters.filter(x => x.filterType === filterType && x.isExclude)"
            :fields="selectedTableColumns"
            sort-by="filterId"
            :sort-desc="true"
            bordered
            empty-text="추가된 라이브 DI가 없습니다."
          >
            <template #head(countType)>
              <span>
                처방 기준 설정
                <b-badge
                  v-b-tooltip.hover.right.html
                  variant="light-secondary"
                  style="padding: 0px; margin-left: 5px;"
                  :title="`<ul style='text-align: left; padding-left: 1rem; margin: 0;'>
                              <li>1일: 라이브DI 노출 기간 중 하루라도 설정한 처방 횟수 이상이면, 타겟그룹에서 제외됩니다.</li>
                              <li>누적: 라이브DI 노출 기간 중 누적 처방 횟수가 설정한 처방 횟수 이상이면, 타겟그룹에서 제외됩니다.</li>
                            </ul>`"
                >
                  <feather-icon icon="InfoIcon" />
                </b-badge>
              </span>
            </template>
            <template #cell(countType)="data">
              <b-form-radio-group
                v-model="data.item.countType"
                :options="codes.targetGroupCountType"
                :disabled="isReadonly"
                value-field="code"
                text-field="label"
              />
            </template>
            <template #cell(minCount)="data">
              <b-form-group class="mb-0">
                <div class="d-flex align-items-center">
                  <b-form-input
                    v-model.number="data.item.minCount"
                    type="number"
                    style="width: 55px;"
                    class="text-right"
                    :disabled="isReadonly"
                    @keyup="event => restrictToNumbers(event, data.item)"
                  />
                  <span class="ml-50">회 이상</span>
                </div>
              </b-form-group>
            </template>
            <template #cell(isDelete)="data">
              <b-button
                variant="link"
                size="sm"
                class="btn-hover-trash"
                style="padding: 0px 4px;"
                :disabled="isReadonly"
                @click.prevent="removeRow(data.item)"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="16"
                  class="text-danger"
                />
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>

    <!-- 라이브DI 선택 모달 -->
    <live-di-select
      v-if="filterType"
      :show-live-di-select="showLiveDiSelect"
      :is-exclude="isExcludeLiveDiSelect"
      :filter-type="filterType"
      :selected-value="targetGroupData.targetGroupFilters.filter(x => x.filterType === filterType && x.isExclude === isExcludeLiveDiSelect).map(i=>i.filterId)"
      @close="liveDiSelect.close"
    />
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import LiveDiSelect from "@/views/apps/contents/druginfo-manage/LiveDiSelect.vue"
import { BBadge, VBTooltip } from 'bootstrap-vue'

export default {
  components: {
    LiveDiSelect,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    targetGroupData: {
      type: Object,
      required: true,
    },
    codes: {
      type: Object,
      required: true,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    filterType: {
      type: Number,
      required: false,
      default: null,
    },
    liveDiToggleState: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const isLiveDi = computed(() => props.liveDiToggleState)
    const countTypeDailyCode = computed(() => props.codes.targetGroupCountType.find(t => t.label === '1일')?.code)

    const selectedTableColumns = [
      {
        key: 'filterId', label: 'ID', sortable: false, thStyle: { width: '8%' },
      },
      {
        key: 'clientName', label: '제약사', sortable: false, thStyle: { width: '10%' },
      },
      { key: 'brandName', label: '제품명', sortable: false },
      { key: 'liveDiTitle', label: '라이브 DI 노출메시지', sortable: false },
      {
        key: 'liveDiPeriod', label: '라이브 DI 노출기간', sortable: false, thStyle: { width: '18%' },
      },
      {
        key: 'countType', label: '처방 기준 설정', sortable: false, thStyle: { width: '14%' }, tdClass: 'text-center',
      },
      {
        key: 'minCount', label: '처방 횟수', sortable: false, thStyle: { width: '13%' }, tdClass: 'text-center',
      },
      {
        key: 'isDelete', label: '', sortable: false, thStyle: { width: '30px' }, tdClass: 'text-center p-0',
      },
    ]

    // 타겟 라이브DI 지정
    const showLiveDiSelect = ref(false)
    const isExcludeLiveDiSelect = ref(false)
    const liveDiSelect = {
      close: rs => {
        showLiveDiSelect.value = false
        if (!rs || rs.length === 0) return
        const existing = props.targetGroupData.targetGroupFilters.filter(x => x.filterType === props.filterType && x.isExclude === isExcludeLiveDiSelect.value) || []

        // 신규 선택 라이브DI만 추가
        const newFilters = []

        rs.forEach(item => {
          const alreadyExists = existing.some(x => x.filterId === item.filterId && x.isExclude === item.isExclude)
          if (!alreadyExists) {
            newFilters.push({
              ...item,
              filterType: props.filterType,
              countType: countTypeDailyCode.value,
              minCount: null,
            })
          }
        })

        props.targetGroupData.targetGroupFilters.push(...newFilters)
      },
    }

    const showTargetGroupFilters = (ftType, isEx) => {
      if (ftType === props.filterType) {
        isExcludeLiveDiSelect.value = isEx
        showLiveDiSelect.value = true
      }
    }

    const removeRow = item => {
      const idx = props.targetGroupData.targetGroupFilters.findIndex(x => x.filterType === props.filterType && x.filterId === item.filterId && x.isExclude === item.isExclude)
      if (idx !== -1) {
        props.targetGroupData.targetGroupFilters.splice(idx, 1)
      }
    }

    const restrictToNumbers = (event, item) => {
      const value = parseInt(event.target.value.replace(/[^\d]/g, ''), 10)

      // eslint-disable-next-line no-param-reassign
      item.minCount = value

      if (value > 999 || value < 1) {
        // eslint-disable-next-line no-param-reassign
        item.minCount = ''
        pushToast('danger', '처방 횟수를 999 이하로 입력해 주세요.')
      }
    }

    return {
      isLiveDi,
      countTypeDailyCode,
      selectedTableColumns,
      showLiveDiSelect,
      isExcludeLiveDiSelect,
      liveDiSelect,
      showTargetGroupFilters,
      removeRow,
      restrictToNumbers,
    }
  },
}
</script>

<style scoped>
.btn-hover-trash:hover {
  background: linear-gradient(to right, #ffe5e5, #ffcccc);
  border-radius: 4px;
}
</style>
